// The site's one place for remembered settings and state (theme, accent, sound, safe mode, crash log, best scores).
// Every key lives under one namespace ("sd.") with a schema version, so a future change can migrate old values instead
// of misreading them. Reads and writes never throw: private browsing, a full quota or blocked storage fall back to an
// in-memory copy for the session. Other tabs of the site see changes (the storage event) and can follow them.

const NS = 'sd.', VERSION = 2;
const memory = new Map<string, string>();
let persistent = true;
try { const k = `${NS}__probe`; localStorage.setItem(k, '1'); localStorage.removeItem(k); } catch { persistent = false; }

function rawGet(k: string) { if (persistent) { try { return localStorage.getItem(NS + k); } catch { /* fall through */ } } return memory.get(k) ?? null; }
function rawSet(k: string, v: string | null) {
  if (v === null) memory.delete(k); else memory.set(k, v);
  if (!persistent) return;
  try { if (v === null) localStorage.removeItem(NS + k); else localStorage.setItem(NS + k, v); }
  catch { /* quota or blocked: the session copy still holds it */ }
}

export const store = {
  persistent,
  get(k: string, fallback: string | null = null) { return rawGet(k) ?? fallback; },
  set(k: string, v: string | null) { rawSet(k, v); },
  json<T>(k: string, fallback: T): T { const v = rawGet(k); if (v === null) return fallback; try { return JSON.parse(v) as T; } catch { return fallback; } },
  setJson(k: string, v: unknown) { try { rawSet(k, JSON.stringify(v)); } catch { /* unserialisable: ignore */ } },
  /** Follow changes made in other tabs. */
  watch(k: string, fn: (v: string | null) => void) { addEventListener('storage', (e) => { if (e.key === NS + k) fn(e.newValue); }); },
};

// migrations: v1 kept SalmanOS settings under "salmanos.*" and the penalty best under "salmanos.pk.best"
if (persistent && Number(rawGet('schema') ?? 0) < VERSION) {
  try {
    for (const k of ['theme', 'accent', 'wall', 'motion', 'muted', 'pk.best']) {
      const old = localStorage.getItem(`salmanos.${k}`);
      if (old !== null && rawGet(`os.${k}`) === null) rawSet(`os.${k}`, old);
      localStorage.removeItem(`salmanos.${k}`);
    }
  } catch { /* nothing to migrate */ }
  rawSet('schema', String(VERSION));
}
